import * as React from 'react';
import { LoadingStateEnum } from '../../../containers_v2/import/model';

export type LoaderState = {
	id: string
	status: LoadingStateEnum,
}

interface LoaderContextType {
	loaderNotify: (id: string, status: LoadingStateEnum | Omit<LoaderState, 'id'>) => void
	loaderRegister: (id: string) => void
	getLoaderStatus: (id: string) => Omit<LoaderState, 'id'>
	loaderManager: LoaderState[]
	setLoaderManager: (loaders: LoaderState[]) => void
}

const defaultBehaviour: LoaderContextType = {
	loaderNotify: () => { return; },
	loaderRegister: () => { return; },
	getLoaderStatus: () => { return { status: LoadingStateEnum.LOADED }; },
	loaderManager: [],
	setLoaderManager: function(): void { return; }
};

const LoaderContext = React.createContext<LoaderContextType>(defaultBehaviour);

export default LoaderContext;
